import React, { useEffect, useMemo } from "react";
import { useSearchParam } from "react-use";
import { Box, Button } from "theme-ui";

import MainLayout from "components/MainLayout";
import SubTitle from "components/SubTitle";
import usePaymentResult from "hooks/usePaymentResult";
import usePaymentCheck from "hooks/usePaymentCheck";
import PaymentSalesSlipInfo from "./components/PaymentSalesSlipInfo";
import PaymentProductList from "./components/PaymentProductList";
import { PaymentStatus } from "api/payment";


export default function PaymentPage() {
  const saleTID = useSearchParam("saleTID") ?? "";

  const {
    data,
    isLoading: isResultLoading,
    refetch,
  } = usePaymentResult(saleTID);
  const {
    data: paymentCheck,
    isIdle,
    isLoading,
    mutate: updatePaymentCheck,
  } = usePaymentCheck();

  useEffect(() => {
    if (!isIdle && isLoading) {
      setTimeout(() => {
        refetch();
      }, 1000);
    }
  }, [isIdle, isLoading, refetch]);

  const buttonText = useMemo(() => {
    if (data?.status === PaymentStatus.COMPLETE) {
      return !!data?.checkDate || paymentCheck?.result === "success"
      ? "확인 완료"
      : "픽업 확인";
    }

    return "결제 실패";
  }, [data, paymentCheck]);

  return (
    <MainLayout
      contentPadding={24}
      hasBackButton={false}
      title='공뿌마켓 QR결제'
    >
      <SubTitle>결제정보</SubTitle>
      <PaymentSalesSlipInfo
        amount={data?.amount ?? 0}
        approvalDate={data?.approvalDate ?? ""}
        approvalNumber={data?.approvalNumber ?? ""}
        businessNumber={data?.bizNumber ?? ""}
      />
      <PaymentProductList
        list={
          data?.productList &&
          data?.productList.map((item) => ({
            productName: item.productName,
            saleQty: item.saleQty,
            saleAmt: item.saleAmt,
          }))
        }
      />

      {buttonText === "픽업 확인" && (
        <Box as='p' my='24px'>
          결제가 완료 되었습니다.
          <br />
          <Box as='span' sx={{ color: "red" }}>
            상품을 매대에서 픽업해주세요.
          </Box>{" "}<br />
          재고가 없을시, 카운터에 문의해주세요.
        </Box>
      )}
      <Box
        marginTop={buttonText === "픽업 확인" ? 0 : "24px"}
        sx={{ textAlign: "center" }}
      >
        <Button
          disabled={
            isLoading ||
            !!data?.checkDate ||
            isResultLoading ||
            paymentCheck?.result === "success" ||
            buttonText === "결제 실패"
          }
          sx={{
            cursor: "pointer",
            backgroundColor: "primaryDark",
            fontSize: "30px",
            fontWeight: "bold",
            height: "60px",
            width: "300px",
            "&:disabled": {
              backgroundColor: "#888",
            },
          }}
          type='button'
          onClick={() => {
            if (saleTID) {
              updatePaymentCheck({ saleTID });
            }
          }}
        >
          {buttonText}
        </Button>
      </Box>
    </MainLayout>
  );
}
